import { render, staticRenderFns } from "./PermissionsAlert.vue?vue&type=template&id=36da0360&"
import script from "./PermissionsAlert.vue?vue&type=script&lang=js&"
export * from "./PermissionsAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports